import { createFileRoute, redirect } from "@tanstack/react-router";
import { createProposalFromEstimate, listProposals } from "@/lib/proposals.functions";

// Convenience route: /admin/estimates/:id/proposal — finds existing proposal or creates one,
// then redirects to the editor.
export const Route = createFileRoute("/_authenticated/admin/estimates/$id/proposal")({
  beforeLoad: async ({ params }) => {
    const existing = await listProposals({ data: { limit: 500 } as any });
    const match = (existing as any[]).find((p) => p.estimate_request_id === params.id);
    if (match) throw redirect({ to: "/admin/proposals/$id", params: { id: match.id } });
    const created = await createProposalFromEstimate({ data: { estimate_id: params.id } });
    throw redirect({ to: "/admin/proposals/$id", params: { id: created.id } });
  },
  component: () => null,
});